import React, { useState } from 'react';
import FilterRow, { SoftEdit } from '../FilterRow/FilterRow';
import { Select } from 'antd';
import { useQuery } from 'react-apollo';
import { FilterTypeProps } from '../FilterListing/FilterListing';
import { CLOUD_ACCOUNT_LIST_QUERY } from 'queries';

function AccountEditor(props: FilterTypeProps) {
  const { values, filterType } = props,
    [softEdit, setSoftEdit] = useState<SoftEdit | null>({
      key: filterType.valueKey,
      value: values[filterType.valueKey]
    }),
    { data, loading, error } = useQuery(CLOUD_ACCOUNT_LIST_QUERY, {
      fetchPolicy: 'cache-and-network'
    }),
    onChange = (update) => {
      setSoftEdit({
        key: filterType.valueKey,
        value: update
      });
    },
    getAccountName = (cloudAccount) => {
      return (
        cloudAccount.nickname || cloudAccount.name || cloudAccount.assumerole_account_id || cloudAccount.account_id
      );
    },
    editor = (
      <Select
        onChange={onChange}
        mode="multiple"
        value={softEdit?.value}
        filterOption={(inputValue, option) => {
          if (!option || !option.props || !option.props.title) {
            return true;
          }
          return new RegExp(inputValue, 'i').test(option.props.title);
        }}
      >
        {data &&
          data.accounts?.items?.map((cloudAccount) => {
            let title = getAccountName(cloudAccount);
            return (
              <Select.Option key={cloudAccount.account_id} title={title}>
                {title}
              </Select.Option>
            );
          })}
      </Select>
    );

  return <FilterRow {...props} editor={editor} softEdit={softEdit} loading={loading} error={error} />;
}

export default AccountEditor;
